import { ErrorHandler } from '@angular/core';

export class CustomErrorHandler extends ErrorHandler {
  handleError(error: any): void {
    console.trace('Custom error handling:', error);
  }
}